import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchDevicesSuccess,
  fetchDevicesFailure,
  toggleDeviceStatusSuccess,
  toggleDeviceStatusFailure,
} from "./actions";
import { FETCH_DEVICES, TOGGLE_DEVICE_STATUS } from "./constants";

function* fetchDevicesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";

  try {
    const { data } = yield call(api(token).get, `/api/device?${query}`);
    const devices = Array.isArray(data) ? data : (data?.data ?? []);
    yield put(fetchDevicesSuccess(devices));
    typeof onSuccess === "function" && onSuccess(devices);
  } catch (e) {
    yield put(fetchDevicesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while fetching devices!"));
  }
}

function* toggleDeviceStatusSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const { data } = yield call(
      api(token).post,
      `/api/device/edit/${payload.id}`,
      payload.data,
    );
    yield put(toggleDeviceStatusSuccess(data));
    yield put(
      successAlert(
        `Device ${payload.data?.is_active ? "activated" : "deactivated"} successfully!`,
      ),
    );
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(toggleDeviceStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while updating device status!"));
  }
}

export default function* DeviceSettingsSaga() {
  yield all([
    takeEvery(FETCH_DEVICES, fetchDevicesSaga),
    takeEvery(TOGGLE_DEVICE_STATUS, toggleDeviceStatusSaga),
  ]);
}
